import { useState } from 'react';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

export function FollowButton({ sellerId, following, followersCount, onChange, size = 'md' }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  if (user?.user_id === sellerId) return null;
  const toggle = async () => {
    if (!user) { toast.error('Connectez-vous pour suivre cette boutique'); nav('/login'); return; }
    setBusy(true);
    try {
      const { data } = await api.post(`/sellers/${sellerId}/follow`);
      onChange?.(data);
      toast.success(data.following ? '❤️ Boutique ajoutée aux favoris — vous serez alertée à chaque live' : 'Boutique retirée des favoris');
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erreur'); }
    finally { setBusy(false); }
  };
  const cls = size === 'sm' ? 'px-3 py-1.5 text-xs' : 'px-4 py-2 text-sm';
  return (
    <button type="button" data-testid="follow-btn" onClick={toggle} disabled={busy} aria-pressed={!!following}
      className={`inline-flex items-center gap-1.5 rounded-full font-bold transition-colors ${cls} ${following ? 'bg-rose-600 text-white hover:bg-rose-500' : 'border border-rose-500/50 text-rose-300 hover:bg-rose-500/10'}`}>
      <Heart className={size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} fill={following ? 'white' : 'none'} />
      {following ? 'Suivie' : 'Suivre'}
      {typeof followersCount === 'number' && <span className="opacity-80" data-testid="followers-count">· {followersCount}</span>}
    </button>
  );
}
